new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {
    
    var bannerHomeFull = $('.home-banner');
    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    const bannerHome = document.querySelector('.home__banner');
    if (bannerHome) {
        let bannerImg = document.querySelector('.home__banner--figure img');
        if (bannerImg) {
            let sizeBanner = bannerImg.getBoundingClientRect().height;
            bannerHome.style.height = sizeBanner + 'px';
        }
    }

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list');
        if(firstCarrousel) {
            $('#product_list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    }
                ]
            });

            $('#product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });

            if($('.vitrine-banner')) {
                $('.vitrine-banner').slick({
                    swipeToSlide: true, 
                    touchThreshold: 100,
                    arrows: false,
                    dots: false,
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [
                            {
                                breakpoint: 991,
                                settings: 'unslick'
                            }
                        ]
                });
            }
        }
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const secondCarrousel = element.querySelector('#product_list2');
        if(secondCarrousel) {
            $('#product_list2').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: 'unslick'
                    }
                ]
            });

            $('#product_list2').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });


    waitForElementToExist('.third-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list3');
        if(firstCarrousel) {
            $('#product_list3').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    }
                ]
            });

            $('#product_list3').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

    waitForElementToExist('.fourth-vitrine').then(element => {
        const firstCarrousel = element.querySelector('#product_list4');
        if(firstCarrousel) {
            $('#product_list4').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 300,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    }
                ]
            });

            $('#product_list4').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });
});